import './MarketingFooter.css';

import React from 'react';

import { Link } from 'react-router-dom';

const MarketingFooter: React.FC = () => (
  <footer className="marketing-footer">
    {/* <div className="marketing-footer-tagline">GO SQUAD GO ✦</div> */}
    <p className="marketing-footer-links">
      © 2026 CheerEval ·{' '}
      <Link to="/terms" className="marketing-footer-link">Terms</Link>
      {' · '}
      <Link to="/privacy" className="marketing-footer-link">Privacy</Link>
      {' · '}
      <Link to="/contact" className="marketing-footer-link">Contact</Link>
    </p>
  </footer>
);

export default MarketingFooter;
